import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import EditableImage from '@/components/base/EditableImage';

export default function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const img = el.querySelector('img');
    if (img) {
      (img as HTMLImageElement).style.opacity = '0';
      img.onload = () => { (img as HTMLImageElement).style.opacity = '1'; };
      if ((img as HTMLImageElement).complete) (img as HTMLImageElement).style.opacity = '1';
    }
  }, []);

  return (
    <section ref={heroRef} className="relative h-screen w-full overflow-hidden">
      <EditableImage
        imageKey="hero-bg"
        src="https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/95294a1bcbd997385565f49e4fe3388e.jpeg"
        alt="Fotografia de casamento"
        containerClassName="absolute inset-0 w-full h-full"
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />

      <div className="relative z-10 h-full flex flex-col justify-end pb-20 md:pb-28 px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white font-normal leading-[1.1] mb-6">
            Transformando
            <br />
            <span className="italic">momentos</span> em
            <br />
            memórias eternas
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-xl leading-relaxed mb-8 font-light">
            Especializada em Casamentos, Famílias e Celebrações. Histórias reais contadas com sensibilidade e intenção.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/portfolio"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-white text-dark text-sm font-semibold hover:bg-white/90 transition-all duration-300 whitespace-nowrap"
            >
              Ver Portfólio
              <i className="ri-arrow-right-line text-sm" />
            </Link>
            <Link
              to="/contato"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-white/40 text-white text-sm font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
            >
              Solicitar Orçamento
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}